var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticClass:"selector",attrs:{"placeholder":_vm.$t('shared.selectChainAndRule'),"value":_vm.value,"options":_vm.chains,"filterable":"","change-on-select":""},on:{"change":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e96d09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/shared/components/chainselector/ChainSelector.vue
// module id = nlNp
// module chunks = 1